import { render, staticRenderFns } from "./PersonRoyalties.vue?vue&type=template&id=2a4ff822&scoped=true"
import script from "./PersonRoyalties.vue?vue&type=script&lang=js"
export * from "./PersonRoyalties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4ff822",
  null
  
)

export default component.exports